import { ThemeContext } from "app/uicomponents/macrocomponents/RootLayout";
import * as React from "react";
import { useContext } from "react";

interface SVGProps extends React.SVGProps<SVGSVGElement> {
  isActive?: boolean;
}

const RelationshipIcon: React.FC<SVGProps> = ({ isActive, ...props }) => {
  const { isDarkMode } = useContext(ThemeContext);
  const finalColor = isActive
    ? "#FFFFFF"
    : props?.fill?.trim()
    ? props.fill.trim()
    : isDarkMode
    ? "#FFFFFF"
    : "#00132E";

  return (
    <svg
      width={17}
      height={25}
      viewBox="0 0 375.57 317.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: finalColor }}
      {...props}
    >
      <path
        d="M187.89,317.2c-7.74,0-15.48-2.69-21.63-8.06L11.26,173.79c-7.15-6.25-11.26-15.28-11.26-24.77v-66.65c0-10.34,4.95-20.21,13.25-26.38L79.67,6.55c10.84-8.07,25.29-8.72,36.82-1.66l67.64,41.44c2.9,1.78,6.62,1.73,9.47-.12l63.19-40.91c11.28-7.31,25.69-7.05,36.71.65l68.03,47.55c8.79,6.15,14.04,16.23,14.04,26.96v70.78c0,9.59-4.17,18.68-11.44,24.93l-154.8,133.13c-6.12,5.27-13.78,7.9-21.44,7.9ZM99.3,24.04c-1.87,0-3.73.59-5.3,1.77L27.58,75.24c-2.24,1.67-3.58,4.33-3.58,7.13v66.65c0,2.57,1.11,5.01,3.04,6.69l155,135.35c3.31,2.89,8.31,2.91,11.64.04l154.8-133.13c1.96-1.69,3.09-4.15,3.09-6.74v-70.78c0-2.9-1.42-5.62-3.8-7.29l-68.03-47.55c-2.98-2.08-6.87-2.15-9.92-.18l-63.19,40.91c-10.56,6.84-24.32,7.01-35.05.44L103.95,25.36c-1.44-.88-3.04-1.32-4.65-1.32Z"
        fill="currentColor"
      />
      <path
        d="M195.48,132.15v-26.77c0-2.65,1.25-5.15,3.38-6.73l26.67-19.85c2.75-2.05,6.47-2.21,9.39-.42l27.16,16.64c2.75,1.69,6.23,1.64,8.94-.11l25.37-16.43c2.86-1.85,6.57-1.79,9.36.17l27.32,19.09c2.24,1.57,3.58,4.14,3.58,6.87v28.42c0,2.44-1.07,4.77-2.92,6.36l-62.16,53.46c-3.16,2.72-7.84,2.7-10.99-.04l-62.24-54.35c-1.82-1.59-2.87-3.9-2.87-6.32Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RelationshipIcon;
